import { forwardRef } from "react";

const TeacherPortalVerticalProgressBar = forwardRef(({ floatProgress, className = "", ...props }, ref) => (
    <div ref={ref} {...props} className={`m-5 h-5 w-4/5 border border-txt_primary ${className}`}>
        <div className="h-full bg-txt_primary" style={{ width: `${Math.round(100 * floatProgress)}%` }} />
    </div>
));

export default TeacherPortalVerticalProgressBar;